import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayProductMovementEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/ProductMovement/`
        this.webApi = new WebApi()
    }

    async changeProductMovement (request) {
        const response = await this.webApi.post(`${this.url}save`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async createProductMovement (request) {
        const response = await this.webApi.post(`${this.url}create`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async getProductMovements (arg) {
        const responses = await this.webApi.post(`${this.url}list`, arg)
        // console.log('responses:', responses)
        if (responses) {
            if (!responses.status_code) {
                if (!responses.error) {
                    return responses
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${responses.status_code}`)
            }
        }
        return null
    }

    async conductProductMovement (request) {
        const response = await this.webApi.post(`${this.url}conduct`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }
}
